import React from 'react';
import styled from 'styled-components';

import { Form, Input, Checkbox, Radio, Space, Button, Divider, Row, Col } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { getTranslatedString } from 'helpers/i18n';
import { fieldsPrototypes } from 'helpers/constants';
import LabelFormField from './LabelFormField';
import IncomeFormField from './IncomeFormField';

const StyledSpace = styled(Space)`
  width: 100%;
  position: relative;
`;

const StyledInput = styled(Input)`
  width: 100%;
`;

const StyledDelete = styled(DeleteOutlined)`
  padding: 34px 18px;
`;

const atLeastOneValueIsSelected = (_, value) =>
  value?.length
    ? Promise.resolve()
    : Promise.reject(new Error(getTranslatedString('landlordPortal.atLeastOneValueIsSelected')));

const FormItemFactory = ({
  name,
  locale,
  label,
  placeholder,
  prototypeOf,
  availableOptions,
  allOptions,
  flag,
}) => {
  switch (prototypeOf) {
    case fieldsPrototypes.SelectField:
      return (
        <StyledSpace direction="vertical" size="middle">
          <Form.Item name={[name, 'translations', locale, 'label']} label={'Label'}>
            <Input placeholder={label} />
          </Form.Item>

          <Form.Item
            name={[name, 'translations', locale, 'placeholder']}
            label={'Select placeholder text'}
          >
            <Input placeholder={placeholder} />
          </Form.Item>

          <Form.Item
            name={[name, 'translations', locale, 'available_options']}
            label="Options"
            rules={[{ validator: atLeastOneValueIsSelected }]}
          >
            <Checkbox.Group options={availableOptions} />
          </Form.Item>

          {flag && (
            <Form.Item
              name={[name, 'flagged_options']}
              label="Flag responses"
              rules={[{ validator: atLeastOneValueIsSelected }]}
            >
              <Checkbox.Group options={availableOptions} />
            </Form.Item>
          )}
        </StyledSpace>
      );
    case fieldsPrototypes.CheckBoxField:
    case fieldsPrototypes.RadioButtonField:
      return (
        <StyledSpace direction="vertical" size="middle">
          <Form.Item name={[name, 'translations', locale, 'label']} label={'Label'}>
            <Input placeholder={label} />
          </Form.Item>

          <Form.Item
            name={[name, 'translations', locale, 'available_options']}
            label={'Options'}
            rules={[{ validator: atLeastOneValueIsSelected }]}
          >
            <Checkbox.Group options={availableOptions} />
          </Form.Item>
        </StyledSpace>
      );

    case fieldsPrototypes.FileUploadField:
      return (
        <StyledSpace direction="vertical" size="middle">
          <Form.Item name={[name, 'translations', locale, 'label']} label="Label">
            <Input placeholder={label} />
          </Form.Item>

          {flag && (
            <Form.Item name={[name, 'flagged_options']} label="Flag response">
              <Radio.Group>
                <Radio value="document_uploaded">Document uploaded</Radio>
                <Radio value="no_document_uploaded">No document uploaded</Radio>
              </Radio.Group>
            </Form.Item>
          )}
        </StyledSpace>
      );

    case fieldsPrototypes.MultipleChoiceMultField:
    case fieldsPrototypes.MultipleChoiceSingleField:
      return (
        <StyledSpace direction="vertical" size="middle">
          <Form.Item name={[name, 'translations', locale, 'label']} label={'Label'}>
            <Input placeholder={label} />
          </Form.Item>

          <Form.List name={[name, 'translations', locale, 'available_options']} label={'Options'}>
            {(fields, { add, remove }) => (
              <>
                <StyledSpace direction="vertical">
                  {fields.map((field, index) => (
                    <Row>
                      <Col span={20}>
                        <Form.Item label={`Choice ${index + 1}`} name={[field.name]}>
                          <StyledInput />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <StyledDelete onClick={() => remove(field.name)} />
                      </Col>
                    </Row>
                  ))}
                </StyledSpace>

                <Form.Item>
                  <Button onClick={() => add()}>Add choice</Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </StyledSpace>
      );
    case fieldsPrototypes.IncomeField:
      return (
        <>
          <LabelFormField locale={locale} name={name} placeholder={label} />

          <Divider />

          <IncomeFormField
            locale={locale}
            name={name}
            availableOptions={availableOptions}
            allOptions={allOptions}
          />
        </>
      );

    default:
      return (
        <StyledSpace direction="vertical" size="middle">
          <Form.Item name={[name, 'translations', locale, 'label']} label="Label">
            <Input placeholder={label} />
          </Form.Item>

          {placeholder && (
            <Form.Item name={[name, 'translations', locale, 'placeholder']} label="placeholder">
              <Input placeholder={placeholder} />
            </Form.Item>
          )}
        </StyledSpace>
      );
  }
};

export default FormItemFactory;
